// extracted by mini-css-extract-plugin
export default {"UserShow":"styles_UserShow__yK+HO","CardContent":"styles_CardContent__39zhO"};